module.exports = __webpack_public_path__ + "img/bj.6fad5690.png";